import React from "react";
import MenuItem from "@mui/material/MenuItem";

const BuildingBlocksMenuListItem4Density = (props) => <MenuItem dense style={{ minHeight: 24 }} {...props} />;

export default BuildingBlocksMenuListItem4Density;
